<template>
  <div>
    <AuthPhone
      :redirectUrl="redirectUrl"
      :authPhoneUrls="isManagerPage ? {
        phoneUrl: '/manager-checkout/verify-client/',
        checkCodeUrl: '/check-code/'
      } : undefined"
      :is-ajax-auth="isAjaxAuth"
      :referrer="referrer"
      :is-auth-modal="isAuthModal"
      :simple-auth="simpleAuth"
      ref="authPhone"
    ></AuthPhone>
    <div v-if="isManagerCheckout !== true" class="modal__hr">{{ $t('popup_or') }}</div>
    <Button v-if="isOnCheckout" type="plain" class="guest-login" @click.native="SET_IS_GUEST(true)">
      {{ $t('guest-auth.title') }}
    </Button>
    <div v-if="isManagerCheckout !== true" class="modal__social-text">{{ $t('popup_social_auth') }}</div>
    <div class="modal__social-btns" v-if="isManagerCheckout !== true">
      <!--      <a @click.prevent="openSocialAuth"-->
      <!--         href="/auth/?authclient=facebook"-->
      <!--         class="modal__social-btn modal__social-btn&#45;&#45;fb">-->
      <!--        <img class="modal__social-btn-icon" src="/img/svgo/social/fb-icon.svg" alt="Facebook icon">-->
      <!--        Facebook-->
      <!--      </a>-->
      <a @click.prevent="openSocialAuth"
         href="/auth/?authclient=google"
         class="modal__social-btn modal__social-btn--g">
        <img class="modal__social-btn-icon" src="/img/svgo/social/g-icon.svg" alt="Google icon">
        Google
      </a>
    </div>
    <p v-if="isManagerCheckout !== true"
       class="modal__agree">
      {{ $t('auth_agreement_text') }} <a :href="urlLanguagePrefix + '/terms-and-conditions/'" target="_blank" class="link agree-terms-link">{{ $t('auth_agreement_link') }}</a>
    </p>
  </div>
</template>

<script>
import AuthPhone from './AuthPhone'
import axios from 'axios'
import { mapActions, mapGetters, mapState } from 'vuex'
import Button from '@/components/inputs/Button.vue'

export default {
  name: 'AuthForm',
  components: {
    Button,
    AuthPhone
  },
  props: {
    isManagerCheckout: Boolean,
    isOnCheckout: {
      type: Boolean,
      default: false
    },
    isAjaxAuth: {
      type: Boolean,
      default: false
    },
    isAuthModal: {
      type: Boolean,
      default: false
    },
    simpleAuth: {
      type: Boolean,
      default: false
    },
    referrer: {
      type: String,
      default: ''
    },
    redirectUrl: String
  },
  data: function () {
    return {}
  },
  created () {
    this.token = document.head.querySelector('meta[name="csrf-token"]').content
    axios.defaults.headers.common['x-csrf-token'] = this.token

    const postParams = new URLSearchParams()
    const { pathname, search } = window.location

    postParams.append('c_back_route', pathname + search)

    axios
      .post(this.urlLanguagePrefix + '/auth/auth/redirect/', postParams)
  },
  methods: {
    ...mapActions([
      'SET_IS_GUEST'
    ]),
    openSocialAuth (e) {
      localStorage.setItem('redirect-route', window.location.href)

      window.open(e.currentTarget.getAttribute('href'), '_blank', 'width= 860,height=480')
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      isManagerPage: state => state.checkout.isManagerPage
    })
  }
}
</script>

<style lang="sass" scoped>
.guest-login
  margin: 0 auto
.modal__hr
  text-align: center
  margin: 20px 0
  position: relative

  &:before,
  &:after
    content: ''
    height: 1px
    width: calc(50% - 35px)
    top: 50%
    position: absolute
    background-color: $nd-border-color

  &:before
    left: 0

  &:after
    right: 0

.modal__social-text
  text-align: center
  margin: 20px 0

.modal__social-btns
  display: flex
  justify-content: center

  @media only screen and (max-width: 450px)

.modal__social-btn
  display: inline-block
  position: relative
  max-width: 145px
  margin: 0 5px
  padding: 0 28px 0 60px
  line-height: 40px
  border-radius: 3px
  border: 1px solid $nd-border-color
  color: $text-color
  background-color: #fff
  font-size: 14px
  font-weight: 500

  &:hover,
  &:focus
    border-color: $nd-focus-border-color

  @media only screen and (min-width: 450px)
    max-width: 162px
    padding: 0 33px 0 70px
    margin: 0 20px

.modal__social-btn-icon
  position: absolute
  width: 26px
  height: 26px
  left: 20px
  top: 50%
  transform: translateY(-50%)

  @media only screen and (min-width: 450px)
    left: 25px

.modal__agree
  font-size: 12px
  line-height: 1.5
  margin: 20px 0 0
  text-align: center

</style>
